import React from "react";
import { CalendarCheck, CheckCircle2, XCircle, MinusCircle } from "lucide-react";

const TONE = {
  success: { cls: "text-emerald-300", Icon: CheckCircle2, label: "Başarılı" },
  failed: { cls: "text-red-300", Icon: XCircle, label: "Başarısız" },
  skipped: { cls: "text-yellow-300", Icon: MinusCircle, label: "Atlandı" },
};

const trDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return "-";
  }
};

/** Son 7 gecenin gece yedeği sonucu. Satır içi, modal/overlay YOK. */
export const NightlyRunsReport = ({ runs }) => (
  <div className="border border-sertex-cyan/20 rounded p-2.5 space-y-1.5" data-testid="nightly-runs-report">
    <div className="hud-text text-sertex-cyan flex items-center gap-1.5">
      <CalendarCheck className="h-3 w-3" /> SON 7 GECE
    </div>

    {!runs?.length ? (
      <div
        className="hud-text text-sertex-textMuted normal-case tracking-normal text-[10px]"
        data-testid="nightly-runs-empty"
      >
        Henüz gece yedeği alınmadı.
      </div>
    ) : (
      <div className="space-y-1">
        {runs.map((r, i) => {
          const tone = TONE[r.result] || TONE.skipped;
          const { Icon } = tone;
          return (
            <div
              key={`${r.started_at}-${i}`}
              data-testid={`nightly-run-row-${i}`}
              data-result={r.result}
              className="flex items-start gap-1.5 hud-text normal-case tracking-normal text-[10px] leading-relaxed"
            >
              <Icon className={`h-3 w-3 mt-0.5 shrink-0 ${tone.cls}`} />
              <span className="text-sertex-textMuted shrink-0">{trDate(r.started_at)}</span>
              <span className={`${tone.cls} shrink-0`}>· {tone.label}</span>
              {r.result === "success" && (
                <span className="text-sertex-textMuted shrink-0">· {r.size_mb} MB</span>
              )}
              {r.reason && (
                <span className="text-sertex-textMuted min-w-0 break-words">· {r.reason}</span>
              )}
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default NightlyRunsReport;
